import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {CommonsService} from "../../../commons/services/commons-service.service";
import {AuthenticationAlertsService} from "../../services/authentication-alerts.service";

export class forgotPasswordViewCtrl implements IController {

  private greetingTime: any;
  private imageGallery: any;
  private image: any;
  private email: any;
  private loading: any;

  /* @ngInject */
  constructor(private $log, private $state, private IamRequests, private authenticationAlertsService: AuthenticationAlertsService,
              private commonsDialogService: CommonsDialogService, private commonsConstants, private commonsService: CommonsService) {
  }

  $onInit() {
    this.greetingTime = this.commonsService.getGreetingTime();
    this.imageGallery = this.commonsConstants.loginImageGalleriesByDayTime[this.greetingTime];

    this.image = this.imageGallery[Math.floor(Math.random() * this.imageGallery.length)];
    this.email = _.get(this.$state.params, 'user.email', '');
    this.loading = false;
  };

  resetClick(form) {
    if (form) {
      form.$setSubmitted(true);

      if (form.$valid) {
        this.loading = true;
        this.IamRequests.emailResetLink(this.email)
          .then(() => {
            return this.authenticationAlertsService.resetPasswordSuccess()
          })
          .then(() => {
            this.$state.go('authentication.login');
          })
          .catch((error) => {
            this.authenticationAlertsService.resetPasswordError(error);
            this.$log.error('Reset password failed', error);
          })
          .finally(() => {
            this.loading = false;
          });

      }

    }
  }

}

angular
  .module('bringoz.admin.authentication')
  .component('forgotPasswordView', {
    bindings: {},
    template: require('./forgot-password-view.html').default,
    controller: forgotPasswordViewCtrl
  });
